import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from "../classNames.js";
import { modifier } from "../modifiers/index.js";
export const Dropdown = ({ children, className, isHoverable, isActive, isRight, isUp, ...props }) => {
    const _class = classNames("dropdown", modifier({ isActive, isHoverable, isRight, isUp }), className);
    return (_jsx("div", { className: _class, ...props, children: children }));
};
export const DropdownDivider = () => _jsx("hr", { className: "dropdown-divider" });
const dropdownItemClassNames = ({ isActive }, className) => classNames("dropdown-item", modifier({ isActive }), className);
export const DropdownItem = ({ children, className, isActive, ...props }) => {
    const _class = dropdownItemClassNames({ isActive }, className);
    return (_jsx("div", { className: _class, ...props, children: children }));
};
export const DropdownItemAnchor = ({ children, className, isActive, ...props }) => {
    const _class = dropdownItemClassNames({ isActive }, className);
    return (_jsx("a", { className: _class, ...props, children: children }));
};
export const DropdownMenu = ({ children, ...props }) => (_jsx("div", { className: "dropdown-menu", ...props, children: _jsx("div", { className: "dropdown-content", children: children }) }));
export const DropdownTrigger = ({ children, className, ...props }) => {
    const _class = classNames("button", className);
    return (_jsx("div", { className: "dropdown-trigger", children: _jsx("button", { className: _class, ...props, children: children }) }));
};
